<loren-page-content>
    <mat-card-title>{{ "toolbar.access" | transloco }}</mat-card-title>
  <div class="row mb-3 mt-3">
    @if(loading()) {
      <div class="m-3">
        <mat-spinner></mat-spinner>
      </div>
    } @else if (error()) {
      <p>{{ "error_page.general_error_message" | transloco }}</p>
    } @else if((!lastSelectedUser() && isHandset) || !isHandset) {
      <div class="col col-md-6">
        @if(users()) {
          <mat-card>
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>{{ "operations.search_here" | transloco }}</mat-label>
              <input #userSearch matInput />
            </mat-form-field>
            <mat-selection-list
              hideSingleSelectionIndicator
              [multiple]="false"
              (selectionChange)="handleUserSelectionChange($event)"
              [(ngModel)]="selectionValue">
              @for(user of users() | lorenUserFilter : userSearch.value; track user)
                {
                <mat-list-option class="loren-user-access-item" [value]="user">
                  <div class="row">
                    <div class="col-1 loren-user-access-img">
                      @if(user.profilePhotoGUID) {
                        <img
                          class="user-pic"
                          [src]="user.profilePhotoGUID | lorenImage | async"
                          alt="profile-picture" />
                      } @else {
                        <img
                          class="user-pic"
                          src="/assets/icons/user-256x256.png"
                          alt="profile-picture" />
                      }
                    </div>
                    <div class="col">
                      {{ user.firstName }} {{ user.lastName }} ({{ user.username }})
                    </div>
                  </div>
                </mat-list-option>
              }
            </mat-selection-list>
          </mat-card>
        }
      </div>
      } @if(selectedUserGroups() && lastSelectedUser()) {
      <div class="col">
        <mat-card>
          <mat-card-title
            class="loren-user-access-title selected-user-groups-title">
            <mat-icon
              class="loren-user-access-icon"
              (click)="clearUserSelection()"
              >arrow_back</mat-icon
              >
              <span
                >{{ lastSelectedUser().firstName }}
                {{ lastSelectedUser().lastName }}</span
                ></mat-card-title
                >
                <mat-tab-group>
                  <mat-tab label="{{ 'features.groups' | transloco }}">
                    <mat-form-field class="w-100 mb-2 mt-3 loren-form-field">
                      <mat-label>{{ "operations.search_here" | transloco }}</mat-label>
                      <input #groupSearch matInput />
                    </mat-form-field>
                    <loren-hierarchy-selector
                      [editable]="false"
                      [filter]="groupSearch.value"
                      [selectedGroups]="selectedUserGroups()"
                      [showAssets]="false"
                      [showCheckboxes]="true"
                      (hierarchySelectionChange)="handleGroupSelectionChange($event)">
                    </loren-hierarchy-selector>
                  </mat-tab>
                  <mat-tab label="{{ 'roles.list' | transloco }}">
                    <mat-form-field class="w-100 mt-3 loren-form-field">
                      <mat-label>{{ "operations.search_here" | transloco }}</mat-label>
                      <input #userSearch matInput />
                    </mat-form-field>
                    @if (roles$ | async; as roles) {
                      <div
                        class="ml-3"
                        style="min-height: 400px">
                        @if (selectedUserRoles$ | async; as userRoles) {
                          @for (role of roles; track role) {
                            <div class="pt-2">
                              <mat-checkbox
                                [checked]="userRoles.includes(role.id)"
                                (change)="toggleRoleForUser($event, role)">
                                {{ role.name }}
                              </mat-checkbox>
                            </div>
                          }
                        }
                      </div>
                    }
                  </mat-tab>
                </mat-tab-group>
              </mat-card>
            </div>
          }
        </div>
      </loren-page-content>
